/** @format */

import React from "react";
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[0-9]/, /\d/, /\d/, " ", " ", "-", " ", " ", /\d/, /\d/, /\d/, /\d/, " ", " ", "-", " ", " ", /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={"\u2000"}
      showMask
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const FormattedInputs = ({ myPhone, setMyPhone }) => {
  const handleChange = (event) => {
    /** 공백, - 표시 제거 */
    const value = event.target.value.replace(/(\s*)/g, "").replace(/(\-)/g, "");
    setMyPhone(value);
  };

  return (
    <div>
      <FormControl className="w-full my-3">
        <InputLabel htmlFor="formatted-text-mask-input">전화번호</InputLabel>
        <Input value={myPhone} onChange={handleChange} name="textmask" id="formatted-text-mask-input" inputComponent={TextMaskCustom} />
      </FormControl>
    </div>
  );
};

export default FormattedInputs;
